import { usePaginatedApi } from "../../../swr/useApi";
import { purchaseOrdersService } from "../../api_client";
import type { PurchaseOrderDto, SalesQueryDto } from "../../../api";

// PO "done" state = delivered. Cast because SalesQueryDto.state enum doesn't
// include PO-specific states — same pattern as purchase_orders_page.tsx.
const STATE_DONE = "done" as unknown as SalesQueryDto["state"];

export function useAdminDashboardDeliveries() {
  return usePaginatedApi<PurchaseOrderDto, SalesQueryDto>({
    key: "admin-dashboard-deliveries",
    serviceMethod: async (query) => purchaseOrdersService.getPurchaseOrders(query),
    query: { state: STATE_DONE, page: 1, pageSize: 3 } as SalesQueryDto,
  });
}
